export const COLUMNS_MATERIAL = [
  { label: "Material", field: "name" },
  { label: "Brand", field: "brand" },
  { label: "Item #", field: "itemNumber" },
  { label: "Description", field: "description" },
];
